export default __webpack_public_path__ + "static/media/10.8150d27f.PNG";